import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TopLayoutComponent } from './top-layout.component';
import { LeftmenuLayoutComponent } from './leftmenu-layout.component';
import {  AuthenticationService } from '../services';
import { Router } from '@angular/router';

@Component({ templateUrl: 'home-layout.component.html' })
export class HomeLayoutComponent {
    public syncTopMenuClick: boolean = true;
    hideLeftmenu: string;
    constructor(
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        private router: Router
        ) { 
            authenticationService.topMenuBar.subscribe(value => {
                this.syncTopMenuClick = !value;
            });
        }

    ngOnInit() {
    }
    onClickOutside(event) {
        this.authenticationService.dynamicOutClick.next("true");
    }

}